export default __webpack_public_path__ + "static/media/frame.7bcc4359.png";